import {useParams} from "react-router-dom";
import {useState} from "react";
import {
  Breadcrumb,
  Card,
  Col,
  Row,
  Typography,
} from "antd";
import TableOneCreateAgendaHistoryNew from "../../components/TableOneCreateAgendaHistoryNew";
import TableTwoCreateAgendaHistoryNew from "../../components/TableTwoCreateAgendaHistoryNew";
import {useTranslation} from "react-i18next";

const { Title } = Typography;

const NewStories = () => {

  const { key } = useParams();
  const [reload, setReload] = useState<any>(0);
  const { t } = useTranslation();

  return(
    <Row justify='center'>
      <Col span={24} className='p-1'>
        <Row gutter={[20, 20]}>
          <Col span={24}>
            <Breadcrumb>
              <Breadcrumb.Item>SCUAPP</Breadcrumb.Item>
              <Breadcrumb.Item>{ key }</Breadcrumb.Item>
            </Breadcrumb>
            <Title level={3}>{t('createNewStoriesAgenda')}</Title>
          </Col>
          <Col span={24}>
            <Row gutter={[10, 30]}>
              <Col span={24}>
                <Card className='border-radius'>
                  <TableOneCreateAgendaHistoryNew setReload={setReload} />
                </Card>
              </Col>
              <Col span={24}>
                <Card className='border-radius'>
                  <TableTwoCreateAgendaHistoryNew reload={reload} />
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default NewStories;
